// extracted by mini-css-extract-plugin
module.exports = {"yotpoReviewsSection":"YotpoReviewsSection_yotpoReviewsSection__ORsLp"};